/* eslint-disable import/no-unused-modules */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IAddAutoOrderTypes, IInvoice } from "shared/interface/types";

const initialState: { AutoOrder: IAddAutoOrderTypes; Invoice: IInvoice } = {
  AutoOrder: {
    id: "",
    customerDetailId: "",
    customerDetail: { name: "" },
    name: "",
    autoPlanId: null,
    planName: "",
    productName: "",
    cartId: "",
    lineOfBussiness: {
      id: null,
      name: ""
    },
    takafulProvider: {
      id: "",
      companyName: ""
    },
    paymentFrequency: {
      id: null,
      name: ""
    },
    planType: {
      id: null,
      name: ""
    }
  },
  Invoice: {
    id: "",
    dueDate: "",
    amount: "",
    currencySymbol: "",
    paidAt: "",
    currencyId: 0,
    tax: "",
    createdById: "",
    updatedById: "",
    createdAt: "",
    updatedAt: "",
    activityFkId: "",
    payerUserId: "",
    paymentStatusId: 0,
    pickupAddress: "",
    activity: {
      id: 0,
      value: ""
    },
    type: {
      id: 0,
      value: ""
    },
    paymentStatus: {
      id: 0,
      key: "",
      value: ""
    },
    paymentMode: {
      id: 0,
      value: ""
    },
    paymentMethod: {
      id: 0,
      value: ""
    },
    currency: {
      id: 0,
      name: "",
      code: "",
      symbol: ""
    },
    totalContributionValue: "",
    amountValue: "",
    updatedBy: {
      id: 0,
      name: ""
    },
    payer: {
      id: "",
      contactNumber: "",
      name: "",
      isActive: true,
      email: "",
      profileImage: "",
      userType: {
        id: 0,
        key: ""
      }
    }
  }
};

const autoOrderSlice = createSlice({
  name: "autoOrder",
  initialState,
  reducers: {
    AddAutoOrder: (state, action) => {
      state.AutoOrder = action.payload;
    },
    AddOrderInvoice: (state, action) => {
      state.Invoice = action.payload;
    },
    DeleteAutoOrder: state => {
      state.AutoOrder = initialState.AutoOrder;
    }
  }
});

export const { AddAutoOrder, AddOrderInvoice, DeleteAutoOrder } = autoOrderSlice.actions;
export default autoOrderSlice.reducer;

export const getAutoOrder = (state: RootState) => state.autoOrder;
export const getInvoice = (state: RootState) => state.autoOrder;
